import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
 
import {LoginComponent} from "./login/login.component";

const routes: Routes = [
    /*{ path: 'user/register', component: SignupComponent },
    { path: 'user/register/mobile', component: MobileComponent },
    { path: 'user/register/otp', component: OtpComponent },
    { path: 'user/register/account', component: AccountComponent },
    { path: 'user/register/billing', component: BillingComponent },
    { path: 'login', component: LoginComponent },

    // otherwise redirect to home
    { path: '**', redirectTo: '' }*/
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule] 
})
export class AuthRoutingModule { }
